module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-10.3c3724fc.png";